import { Card } from '@/components/ui/card';

import { useNetBenefitData } from '@/features/group-pricing/hooks/use-net-benefit-data';
import { cn } from '@/lib/utils';
import { Check, X } from 'lucide-react';
import { DebugInfo } from '../debug-info';

export function TakeGroupCard() {
	const { groupResult } = useNetBenefitData();
	const groupMessage = groupResult.takeGroup
		? 'Take Group!'
		: 'Reconsider Group';

	return (
		<div className='tw-mt-6'>
			<div className='tw-relative'>
				<Card
					className={cn(
						'tw-p-4 tw-inline-block tw-min-w-[150px] tw-cursor-pointer tw-transition-all tw-border-2',
						groupResult.takeGroup
							? 'tw-border-primary tw-bg-secondary'
							: 'tw-border-transparent tw-bg-destructive/10',
					)}
				>
					<div className='tw-flex tw-items-center tw-justify-between'>
						<span className='tw-font-medium'>
							<DebugInfo
								data={groupResult}
								label={`${groupMessage} - Click for details.`}
							/>
						</span>
						{groupResult.takeGroup ? (
							<Check className='tw-h-4 tw-w-4 tw-text-primary tw-ml-2' />
						) : (
							<X className='tw-h-4 tw-w-4 tw-text-destructive tw-ml-2' />
						)}
					</div>
				</Card>
			</div>
		</div>
	);
}
